interface CreateKaapiK8sInstallerConfigTemplatesParams {
  name: string
  namespace: string
}

export const createKaapiK8sInstallerConfigTemplateBody = ({
  name,
  namespace,
}: CreateKaapiK8sInstallerConfigTemplatesParams) => {
  return {
    apiVersion: 'infrastructure.cluster.x-k8s.io/v1beta1',
    kind: 'K8sInstallerConfigTemplate',
    metadata: { name, namespace },
    spec: { template: { spec: { bundleRepo: 'quay.io/platform9', bundleType: 'k8s' } } },
  }
}
